import React, { Component } from "react";

class DropdownIcon extends Component {
  render() {
    const { className, color, open } = this.props;
    return (
      <span className={className} style={{ color, marginLeft: '1em' }} onClick={this.props.toggle}>
        { open ? <i className="ion-arrow-down-b" /> : <i className="ion-arrow-left-b" /> }
      </span>
    );
  }
}

export default DropdownIcon;
